<script lang="ts">
  import { getShowContext } from "./showContext";
  import SmoreLogo from "./SmoreLogo.svg";
  // import SmoreFire from "../show_author_new/newsletterSettings/SmoreFire.svg";
  import { isLoggedIn } from "@ui/currentUser";
  import { onMount } from "svelte";
  import WistiaVideo from "@ui/WistiaVideo.svelte";

  const context = getShowContext();
  const loggedIn = isLoggedIn;
  let pageFooter: HTMLDivElement;

  onMount(() => {
    const endOfPage = document.querySelector(".end-of-page");
    if (endOfPage && pageFooter) {
      endOfPage.parentNode?.insertBefore(pageFooter, endOfPage.nextSibling);
    }
  });
</script>

{#if context.showPromotionBar}
  {#if context.showFullBar}
    <div bind:this={pageFooter} class="bottom-0 left-0 right-0 z-50 mt-4 -m-4 bg-white shadow-inner notranslate page-footer no-print">
      <!-- Old new footer design -->
      <!-- <div class="flex items-center justify-between h-full px-4 mx-auto content">
      <div class="flex items-center">
        <img src={SmoreFire} alt="Smore fire" class="w-5" />
        <div class="ml-2 font-normal text-16">This is a free newsletter created on Smore</div>
      </div>
      <a href="/signup" class="px-5 py-1 font-bold text-white border-2 border-white rounded text-16">Join Smore</a>
    </div> -->

      <div class="flex items-center justify-center w-full mx-auto ">
        <div class="flex flex-wrap items-center justify-start px-4 py-8 md:flex-nowrap ">
          <div class="">
            <h2 class="flex items-center leading-snug text-14 text-nxgray-600">
              Created with <img class="-mt-0.5 w-24 ml-2 mr-5" src={context.smoreImageUrl} alt="Smore" />
            </h2>
            <h3 class="mt-2 font-medium text-15">Communicate quickly and effectively with interactive newsletters.</h3>
            <p class="mt-1 font-normal leading-snug text-14 text-nxgray-500">
              Smore empowers educators to connect with their community, streamline school communications,<br /> and increase engagement.
            </p>
            <div class="flex items-center justify-start mt-4 ">
              {#if $loggedIn}
                <a
                  data-button-id="flyer-footer-try-it-now"
                  href="https://www.smore.com"
                  class="inline-block px-10 py-2 font-bold text-white bg-orange-600 rounded shadow has-tooltip hover:bg-orange-500 clickable text-16 pop-above"
                  >Create a newsletter</a>
              {:else}
                <a
                  href="/app/pages/new?s=nl_footer"
                  class="inline-block px-4 py-2 font-bold text-white truncate bg-orange-600 rounded shadow md:px-10 has-tooltip hover:bg-orange-500 clickable text-16"
                  >Create a newsletter</a>
              {/if}
              <div class="hidden ml-4 md:block">
                <img src={context.itsAwesomeImageUrl} alt="Get started with free school newsletter templates!" />
              </div>
            </div>
          </div>
          <div class="mt-10 ml-0 md:ml-10 md:mt-0 bg-nxgray-100">
            <WistiaVideo videoId="mx8vcck37v" />
          </div>
        </div>
      </div>
    </div>
  {:else if context.showMinimalBar}
    <div bind:this={pageFooter} class="bottom-0 left-0 right-0 z-50 notranslate page-footer no-tablet no-mobile no-print">
      <div class="px-4 py-1 mx-auto text-gray-500 bg-black rounded-t w-max text-14">
        <a href="/app/marketing/index?ref=powered" target="_blank" title="Powered by Smore tag" class="flex items-center">
          <span>Powered by </span>
          <img src={SmoreLogo} alt="Smore logo" class="h-4 ml-2" />
        </a>
      </div>
    </div>
  {/if}
{/if}
